<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Expiry Date Synchronizing
            </div>
            <p>
                If you manage several licenses in your account, you can choose to align the future subscription renewals to a common date. This will allow you to renew all subscriptions at the same time.
            </p>
            <p>
                Follow the steps below to configure the <span class="text-weight-medium">Expiry Date Sync</span> setting.
            </p>

            <ol class='help-listStyle'>
                <li>
                    <p>
                        Sign into your online account by clicking <router-link to='/myaccount/licenses' target="_blank">here</router-link>. If you are already signed in, select <span class='text-weight-medium'>My Account</span>.
                    </p>
                    <p>
                        <img id='ActivateImg' class='img-fit' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/NavigationBarAccountIcon.png')"
                             alt='Account Icon in the Navigation Bar' />
                    </p>
                </li>
                <li>
                    <p>Select the <span class="text-weight-medium">Licenses & Activations</span> category.</p>
                    <p>
                        <img id='UpdateImg' class='img-fit' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/LicensesAndActivationsBtn.png')"
                             alt='Licenses & Activations Button' />
                    </p>
                </li>
                <li>
                    <p>Click on the <span class="text-weight-medium">Prefered License Expiry Date</span> toggle to turn the setting on or off.</p>
                    <p>
                        <img class="img-fit" style="border: 1px solid lightgrey" :src="require('@/assets/img/help/ExpirySyncDateToggle.png')" alt="Expiry Sync Date Toggle" />
                    </p>
                </li>
                <li>
                    <p>If the setting has never been used the <span class="text-weight-medium">Expiry Sync Date Editor</span> will pop up automatically. To edit an existing date set, click on the date edit link.</p>
                    <p>
                        <img class="img-fit" style="border: 1px solid lightgrey" :src="require('@/assets/img/help/ExpirySyncDateEditBtn.png')" alt="Expiry Sync Date Edit Button" />
                    </p>
                </li>
                <li>
                    <p>When the editor is open, click on the month and day you would like your licenses to expire on when they are renewed and click save. From now on, when you add license renewals to your cart, they will automatically be set to expire on the next instance of your preferred date.</p>
                    <p>
                        <img class="img-fit" style="border: 1px solid lightgrey" :src="require('@/assets/img/help/ExpirySyncDateEditor.png')" alt="Expiry Sync Date Editor" />
                    </p>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'expiry-sync-date',
    }
</script>
